const education = {
  hero: {
    title: 'Pegasus Arms 25 UAV Operator Training Center',
    description:
      'The place where we train those who change the course of war. We build a team of pilots who can operate advanced-generation UAVs. Our graduates are not just pilots – they are battle-proven specialists able to perform effectively in the toughest environments.',
  },
  offer: {
    title: 'What we offer',
    paragraphs: [
      'Three weeks of intensive course run by battle-proven instructors.',
      'The program combines a theoretical course and hands-on training in highly realistic, combat-like conditions.',
    ],
    items: [
      '36 academic hours of theory and practice',
      '36 hours of flight training',
      'Operation of the PEGASUS ARMS 25 strike UAS with various combat payload configurations',
      'Accomplishment of battlefield missions and work in harsh weather conditions',
      'Counter-UAS operations and employment of EW/ES and counter-UAS assets',
      'Comprehensive examination (theory + test flight)',
      'Certificate authorizing combat use of Pegasus Arms 25',
    ],
  },
}
export default education
